import BreadProduct from 'models/BreadProduct'

export const breadTypeOptions = [
  {
    value: '',
    label: 'Type',
    isDisabled: true,
  },
  {
    value: 'Loaf',
    label: 'Loaf',
  },
  { value: 'Buns', label: 'Buns' },
  { value: 'Rolls', label: 'Rolls' },
]

export const packagingInitialState = {
  category: BreadProduct.category,
  subCategory: BreadProduct.subCategory,
  BreadType: {
    value: breadTypeOptions[0].value,
    label: breadTypeOptions[0].label,
  },
  BreadSize: '',
  WholeWheatCert: BreadProduct.WholeWheatCert,
}
